module.exports = window["SocketContext"];